import { render, staticRenderFns } from "./addnum.vue?vue&type=template&id=d7a0c7f0&"
import script from "./addnum.vue?vue&type=script&lang=js&"
export * from "./addnum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports